import React, { useState, useEffect } from "react";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import DataTable_Component from "../../components/vehicleinoutfromhub/Data Table Component/index";
import Status_modal from "../../components/manageInvoice/status_modal/index";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Layouts from "../../layouts/layouts";
import VehicleinoutDetailModal from "../../components/vehicleinoutfromhub/Vehicleinout Details";
import * as XLSX from "xlsx";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "react-tooltip";
import { Bar } from "react-chartjs-2";
import "chart.js/auto";

import {
  faEye,
  faBatteryFull,
  faBatteryThreeQuarters,
  faBatteryHalf,
  faBatteryQuarter,
  faBatteryEmpty,
} from "@fortawesome/free-solid-svg-icons";

const LiveLocationCell = ({ coordinates, id }) => {
  const [address, setAddress] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchAddress = async () => {
    if (!coordinates?.latitude || !coordinates?.longitude) {
      setAddress("No coordinates available");
      return;
    }

    const { latitude, longitude } = coordinates;
    setLoading(true);

    try {
      const res = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${process.env.REACT_APP_BASE_API}`,
      );
      const data = await res.json();
      if (data.status === "OK" && data.results.length > 0) {
        setAddress(data.results[0].formatted_address);
      } else {
        setAddress("Address not found");
      }
    } catch (err) {
      console.error("Error fetching address:", err);
      setAddress("Error fetching address");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ position: "relative", zIndex: 1 }}>
      {address ? (
        <>
          <span>{address.slice(0, 20)}...</span>
          <FontAwesomeIcon
            icon={faInfoCircle}
            data-tooltip-id={`tooltip-live-location-${id}`}
            data-tooltip-content={address}
            style={{ cursor: "pointer", marginLeft: "5px" }}
          />
          <Tooltip
            id={`tooltip-live-location-${id}`}
            place="bottom"
            style={{ zIndex: 9999, backgroundColor: "black" }}
          />
        </>
      ) : (
        <button
          onClick={fetchAddress}
          disabled={loading}
          style={{
            padding: "4px 8px",
            background: "#007bff",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            fontSize: "12px",
          }}
        >
          {loading ? "Loading..." : "Click"}
        </button>
      )}
    </div>
  );
};

export default function VehicleInOut() {
  const title = "Vehicle In/Out from Hub ";
  const [apistate, setApiState] = useState([]);
  const [apicol, setApiCol] = useState([]);
  const [selectVal, setSelectval] = useState([]);
  const [openModal, setOpenModal] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [date, setDate] = useState(new Date().toISOString().split("T")[0]);
  const [selectedVehicleinout, setSelectedVehicleinout] = useState(null);
  const [showVehicleinoutDetailModal, setShowVehicleinoutDetailModal] =
    useState(false);
  const [vehicles, setVehicles] = useState([]);
  const [chartData, setChartData] = useState({});
  const [activeVehicleCount, setActiveVehicleCount] = useState(0);
  const [selectedHub, setSelectedHub] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [totalRows, setTotalRows] = useState(0);
  const [allHubs, setAllHubs] = useState([]);

  const [searchText, setSearchText] = useState("");
  const [workingHoursFilter, setWorkingHoursFilter] = useState("");

  const formatToReadable = (decimalHours) => {
    if (!decimalHours) return "0 hr 0 minutes";

    let hours = Math.floor(decimalHours);
    let minutes = Math.round((decimalHours - hours) * 60);

    if (minutes === 60) {
      hours += 1;
      minutes = 0;
    }

    return `${hours} hr ${minutes} minutes`;
  };

  const columns = [
    {
      name: <b>Vehicle Number</b>,
      selector: (row) => row.numberplate || "N/A",
      sortable: true,
    },
    {
      name: <b>Working Hours</b>,
      // selector: (row) => calculateWorkingHours(row.vehicleTimings),
      selector: (row) => formatToReadable(row.workingHours),
      sortable: true,
    },
    {
      name: <b>Arrived Timings</b>,
      cell: (row) => renderTimings(row, "arrived assigned_location"),
      sortable: false,
    },
    {
      name: <b>Left Timings</b>,
      cell: (row) => renderTimings(row, "left assigned_location"),
      sortable: false,
    },

    {
      name: <b>Left Charging Location</b>,
      cell: (row) => renderTimings(row, "left charging_location"),
      sortable: false,
    },
    {
      name: <b>Arrived Charging Location</b>,
      cell: (row) => renderTimings(row, "arrived charging_location"),
      sortable: false,
    },

    {
      name: <b>Reached Count</b>,
      selector: (row) => row.reachedCount || "-",
      sortable: true,
    },
    {
      name: <b>Left Count</b>,
      selector: (row) => row.leftCount || "-",
      sortable: true,
    },
    {
      name: <b>Hubs</b>,
      cell: (row) => {
        if (Array.isArray(row.hubs) && row.hubs.length > 0) {
          return (
            <div style={{ maxWidth: "300px", whiteSpace: "pre-wrap" }}>
              {row.hubs.map((hub, index) => (
                <div key={index} style={{ marginBottom: "4px" }}>
                  {hub.name}
                </div>
              ))}
            </div>
          );
        }
        return "N/A";
      },
      sortable: false,
    },
    {
      name: <b>Action</b>,
      cell: (row) => (
        <>
          <button
            onClick={() => viewVehicleinout(row)}
            className="btn btn-primary btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faEye} />
          </button>
        </>
      ),
    },
  ];

  const renderTimings = (row, type) => {
    if (!Array.isArray(row.vehicleTimings)) return "N/A";

    const filtered = row.vehicleTimings.filter((t) => t.type === type);

    return filtered.length > 0 ? (
      <div style={{ maxWidth: "300px", whiteSpace: "pre-wrap" }}>
        {filtered.map((timing, index) => (
          <div key={index} style={{ marginBottom: "8px" }}>
            🕒 <b>{new Date(timing.time).toLocaleString()}</b>
            <br />
            👤 Driver:{" "}
            {timing.currentDriverName ||
              timing.currentDriver?.name ||
              row.vehicleDetail?.currentDriverName ||
              "--"}
            <br />
            🔋 Battery: {timing.batteryPercentage}%
            <br />
            📍{" "}
            <LiveLocationCell
              coordinates={timing.liveCoordinates}
              id={row.numberplate + "-" + index}
            />
          </div>
        ))}
      </div>
    ) : (
      "-"
    );
  };

  const viewVehicleinout = (vehicleinout) => {
    setSelectedVehicleinout(vehicleinout);
    setShowVehicleinoutDetailModal(true);
  };

  const fetchVehicles = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) return;

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v1/vehicles`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const allVehicles = response.data.vehicles || [];
      setVehicles(allVehicles);

      const activeVehicles = allVehicles.filter(
        (vehicle) => vehicle.status?.trim().toLowerCase() === "active",
      );

      setActiveVehicleCount(activeVehicles.length);
    } catch (error) {
      console.error("Error fetching vehicles:", error);
      setVehicles([]);
      setActiveVehicleCount(0);
    }
  };

  const fetchAllHubs = async () => {
    try {
      const token = localStorage.getItem("token");

      if (!token) return;

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v1/hubs`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setAllHubs(response.data.hubs || []);
    } catch (error) {
      console.log("Error fetching hubs:", error);
    }
  };

  useEffect(() => {
    let filteredVehicles = vehicles;

    // Apply hub filter
    if (selectedHub) {
      filteredVehicles = filteredVehicles.filter((v) =>
        v.id_hub?.some((h) =>
          h.name?.toLowerCase().includes(selectedHub.toLowerCase()),
        ),
      );
    }

    // Count active
    const activeVehicles = filteredVehicles.filter(
      (v) => v.status?.trim().toLowerCase() === "active",
    );

    setActiveVehicleCount(activeVehicles.length);
  }, [vehicles, selectedHub]);

  useEffect(() => {
    fetchVehicles();
    fetchAllHubs();
  }, []);

  const fetchData = async (
    selectedDate = date,
    page = currentPage,
    limit = rowsPerPage,
    search = searchText,
    workingHours = workingHoursFilter,
    selectedHubFilter = selectedHub,
  ) => {
    try {
      const token = localStorage.getItem("token");

      if (!token) return;

      let query = `?page=${page}&limit=${limit}&date=${selectedDate}`;

      // ✅ search
      if (search) {
        query += `&search=${search}`;
      }

      // ✅ working hours
      if (workingHours) {
        query += `&workingHours=${workingHours}`;
      }

      // ✅ hub
      if (selectedHubFilter) {
        query += `&hub=${selectedHubFilter}`;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v4/vehicle-tracking/track-vehicle-locations${query}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const vehiclesData = response.data.vehicles || [];

      setApiState(vehiclesData);

      setTotalRows(response.data.pagination?.totalVehicles || 0);
      setChartData(response.data.chartData || {});
      setApiCol(columns);
    } catch (error) {
      console.log("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData(
      date,
      currentPage,
      rowsPerPage,
      searchText,
      workingHoursFilter,
      selectedHub,
    );
  }, [
    date,
    currentPage,
    rowsPerPage,
    searchText,
    workingHoursFilter,
    selectedHub,
  ]);

  return (
    <>
      <Layouts />
      <Status_modal row={selectVal} openModal={openModal} />
      <VehicleinoutDetailModal
        show={showVehicleinoutDetailModal}
        onHide={() => setShowVehicleinoutDetailModal(false)}
        vehicleinout={selectedVehicleinout}
      />
      <div className="container-fluid">
        <div className="row my-3">
          <div className="col-12">
            <div
              className="card"
              style={{
                borderTop: "2px solid #4723d9",
                boxShadow: "none",
              }}
            >
              {" "}
              <div className="card-header d-flex justify-content-between border-bottom pb-1">
                <h4>{title}</h4>
                {/* <div className="d-flex justify-content mb-3">
                  <button className="btn btn-success">
                    Active Vehicles: {activeVehicleCount}
                  </button>
                </div> */}
              </div>
              <div className="card-body">
                <div className="mb-4" style={{ height: "400px" }}>
                  {chartData.labels ? (
                    <Bar
                      data={chartData}
                      options={{
                        indexAxis: "y",

                        responsive: true,
                        maintainAspectRatio: false,

                        plugins: {
                          legend: { display: false },

                          title: {
                            display: true,
                            text: "Vehicle Working Hours Distribution",
                            font: {
                              size: 18,
                              weight: "bold",
                            },
                          },
                        },

                        scales: {
                          x: {
                            beginAtZero: true,
                            title: {
                              display: true,
                              text: "Number of Vehicles",
                              font: { size: 14, weight: "bold" },
                            },
                            ticks: {
                              font: { size: 13 },
                            },
                            grid: {
                              color: "rgba(0,0,0,0.08)",
                            },
                          },

                          y: {
                            title: {
                              display: true,
                              text: "Working Hours Range",
                              font: { size: 14, weight: "bold" },
                            },
                            ticks: {
                              padding: 12,
                              font: {
                                size: 14,
                                weight: "bold",
                              },
                            },
                            grid: {
                              display: false,
                            },
                          },
                        },
                      }}
                    />
                  ) : (
                    <p>Loading chart...</p>
                  )}
                </div>
                <DataTable_Component
                  allHubs={allHubs}
                  searchBy="numberplate"
                  title_btn={false}
                  apidata={apistate}
                  columns={apicol}
                  applyFiltersExternally={fetchData}
                  onHubChange={setSelectedHub}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  rowsPerPage={rowsPerPage}
                  setRowsPerPage={setRowsPerPage}
                  totalRows={totalRows}
                  searchText={searchText}
                  setSearchText={setSearchText}
                  workingHoursFilter={workingHoursFilter}
                  setWorkingHoursFilter={setWorkingHoursFilter}
                  date={date}
                  setDate={setDate}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
